import Modal from "@cloudscape-design/components/modal";
import {Box, SpaceBetween, Button, CopyToClipboard, Icon, Flashbar, Container} from "@cloudscape-design/components";
import { handleDownload, openInNewTab } from "utils/Utils";
import AppConfig from "configs/AppConfig";

const DomainsConfigModal = ({domainName, nameServers, isVisible, onDismiss}:{domainName:string, nameServers:string[], isVisible:boolean, onDismiss:()=>void}) => {
  return (
    <Modal
      onDismiss={onDismiss}
      visible={isVisible}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="normal" onClick={onDismiss}>Close</Button>
            <Button variant="primary" onClick={()=>{handleDownload(`${domainName}-configs.txt`, nameServers)}}>
                <SpaceBetween direction="horizontal" size="xxs" alignItems="center">
                    <Icon name="download" />
                    <span>Download</span>
                </SpaceBetween>
            </Button>
          </SpaceBetween>
        </Box>
      }
      header={<><Icon name="globe" size="medium" /> {domainName}</>}
    >
        <p>To connect your domain, add the following nameservers to your domain’s DNS configuration. For detailed instructions, see our <strong className="main-field clickable" onClick={()=>{openInNewTab(`${AppConfig.ASWAR_DOCUMENTATION_URL}/docs/Guides/custom-domains-architecture#2-nameservers-configuration`)}}>documentation</strong>.</p>
        
        <Container>
          <div className="domains-list">
            {nameServers.map((name, index)=> (
              <div key={index} className="domain-item">
                <span>{name}</span> 
                <CopyToClipboard
                  copyButtonAriaLabel="Copy"
                  copyErrorText="Failed to copy"
                  copySuccessText="copied"
                  textToCopy={name}
                  variant="icon"
                />
              </div>
            ))}
          </div>
        </Container>
        
        <br />

        <Flashbar items={[{type: "warning", content: "Please download these nameservers now, as they will not be available after verification."}]} />
    </Modal>
  );
}

export default DomainsConfigModal;